import { Button } from '@material-ui/core';
import { Colors, useGlobalStyles } from 'utils';
import { MinLoader } from '../loader';
import React from 'react';

export const CreateChancel = ({
                                create,
                                chancel,
                                onCreate,
                                onClose,
                                classes,
                                loader,
                                disabled,
                                width,
                              }) => {
  const globalStyles = useGlobalStyles();

  return (
    <div className={`${globalStyles.buttonsStyle} ${classes ? classes : ''}`}>
      <Button
        style={{
          textTransform: 'capitalize',
          width: width ? width : '238px',
          height: '48px',
          background: Colors.ThemeGreen,
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '600',
          color: Colors.TextWhite,
          opacity: loader === true || disabled ? .7 : 1,
        }}
        onClick={onCreate}
        disabled={loader === true ? true : disabled}
      >
        {loader === true ?
          <MinLoader margin={'0'} color={Colors.TextWhite} />
          :
          create
        }
      </Button>
      <Button
        style={{
          textTransform: 'capitalize',
          width: width ? width : '238px',
          height: '48px',
          background: Colors.ThemeDarkGray,
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '600',
          color: Colors.TextPrimary,
        }}
        onClick={onClose}
      >
        {chancel}
      </Button>
    </div>
  );
};
